import * as React from 'react';
import { Button } from '@grandvisionhq/elements';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { useStoreFinderContext } from '../../context/StoreFinder/context.js';
import '@swc/helpers';
import '@grandvisionhq/locations';
import '@grandvisionhq/utils';
import 'lodash/deburr';
import '../../context/StoreFinderSlots/context.js';

const StoreFinderFilterWarning = ({ clearAllFilters , hasActiveFilters , applyActiveFilters ,  })=>{
    const { getLabel  } = useIntl();
    const { stores  } = useStoreFinderContext();
    const filteredStores = React.useMemo(()=>applyActiveFilters(stores)
    , [
        stores,
        applyActiveFilters
    ]);
    if (stores.length === 0) {
        return null;
    }
    if (!hasActiveFilters) {
        return null;
    }
    if (filteredStores.length !== 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Alert, {
        variant: "warning",
        className: "alert-m-default"
    }, /*#__PURE__*/ React.createElement("div", null, getLabel('stores.page.search.filters.warning'), ' ', /*#__PURE__*/ React.createElement(Button, {
        className: "store-finder-stores-v2__clear-filters-action",
        variant: "ghost",
        onClick: clearAllFilters
    }, getLabel('stores.page.search.filters.clearButton'))));
};

export { StoreFinderFilterWarning, StoreFinderFilterWarning as default };
//# sourceMappingURL=StoreFinderFilterWarning.js.map
